<template functional>
    <a-sub-menu
        :key="props.menuInfo.key"
    >
    <span slot="title">
      <a-icon type="folder" /><span>{{ props.menuInfo.title }}</span>
    </span>
        <template v-for="item in props.menuInfo.children">
            <a-menu-item
                v-if="!item.children"
                :key="item.key"
            >
                <!--<a-icon type="user" />-->
                <span>
                    {{ item.title }}
<!--                    <a-badge count="44" :numberStyle="{backgroundColor: '#52c41a', color: '#fff', boxShadow: 'none', right: '-5px'}" />-->
<!--                    <a-badge dot :numberStyle="{boxShadow: 'none',right: '-5px'}">-->
<!--                      {{ item.title }}-->
<!--                    </a-badge>-->
                </span>
            </a-menu-item>
            <sub-menu
                v-else
                :key="item.key"
                :menu-info="item"
            />
        </template>
    </a-sub-menu>
</template>
<script>
    export default {
        props: ['menuInfo']
    };
</script>
